<template>
    <div class="box grow verification-code" v-html="captcha" @click="getCaptcha">
    </div>
</template>
<script>
    export default {
        name: 'captcha',
        data() {
            return {
                captcha: '',
            }
        },
        methods: {
            getCaptcha() {
                // 获得验证码
                this.$api.getCaptcha().then((str) => {
                    this.captcha = str.data.data;
                })
            },
        },
        mounted() {
            this.getCaptcha()
        },
        components: {}
    }
</script>

<style lang="scss">
    .verification-code {
        border: 1px solid #000;
        height: 52px;
        text-align: center;
        margin-top: -15px;
        overflow: hidden;

    }

    @media (max-width: 768px) {
        .verification-code {
            margin-top: 20px !important;
        }
        .text-align-center {
            text-align: center !important;
        }
    }
</style>